import React, { useCallback, useMemo, useState } from 'react';
import {
  SupportContext,
  type SupportContextValue,
} from './supportContextValue';

export const SupportContextProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [context, setContextState] = useState<SupportContextValue>({});

  const setContext = useCallback((ctx: SupportContextValue) => {
    setContextState(ctx);
  }, []);

  const clearContext = useCallback(() => {
    setContextState({});
  }, []);

  const value = useMemo(
    () => ({ context, setContext, clearContext }),
    [context, setContext, clearContext]
  );

  return (
    <SupportContext.Provider value={value}>{children}</SupportContext.Provider>
  );
};
